<template>
  <div class="muse-player">
    <!-- Your MusePlayer content here -->
    <!-- For example, the video element -->
    <div id="muse-player"></div>

    <!-- Overlay content -->
    <div v-if="videoOptions.showOverlay" class="overlay-content">
      <slot name="overlay-content"></slot>
    </div>
  </div>
</template>


<script>
import { ref, toRefs, watch, onMounted, onUnmounted} from '@vue/composition-api';
import { useScriptTag } from '@vueuse/core';

export default {
    data() {
    return {
      showOverlay: true,
    };
  },
  props: {
      widthPercentage: {
    type: Number,
    default: 100,
  },
    videoOptions: {
      type: Object,
      default: () => ({
        video: null,

      })
    }
  },
  setup(props, { emit }) {
    const { widthPercentage } = toRefs(props);
    const player = ref(null);
    const playerRef = ref(null);
    const width = ref("100%");
    console.log("MusePlayer: props:")
    console.log(props)
    watch(
      () => props.videoOptions.video,
      (video) => {
        if (!video || !player.value) return;
        if (video === player.value.options.video) return;
        player.value.setVideo(video);
      },
      {
        deep: true,
        immediate: true
      }
    );
    

    useScriptTag('https://muse.ai/static/js/embed-player.min.js', function () {
      player.value = window.MusePlayer({
        container: '#muse-player',
        width: width.value,
        ...props.videoOptions
      });

      player.value.on('play', () => {
        console.log("MusePlayer::Emits play()")
        emit('play');
      });


      player.value.on('pause', () => {
        console.log("MusePlayer::Emits pause()")
        emit('pause');
      });
    });



  onMounted(() => {
     const playerRect = playerRef.value.getBoundingClientRect();
      width.value = `${playerRect.width * (widthPercentage.value / 100)}px`;
      player.value.play = () => {
        console.log("MusePlayer::play()")
        console.log("***** player.value.play - player.value:", player.value);
        player.value.playVideo(); // Call the playVideo method of the MusePlayer instance
      };

      player.value.pause = () => {
        player.value.pauseVideo(); // Call the pauseVideo method of the MusePlayer instance
      };

      player.value.setVideo = (videoID) => {
        console.log("***** setVideo - player.value:", player.value);
        if (!player.value) return;
          player.value.setVideo(videoID);
      };
    
    });


  onUnmounted(() => {
      player.value.off('play');
      player.value.off('pause');
    });

    return {
      player,
      ...this
    };
  }
};
</script>


<style>

.overlay-content {
  position: absolute;
  top: 50;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Add a semi-transparent background for the overlay effect */
  /* Add any other styles for the overlay content */
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


